const ErrorMessagesService = {
	getConvertedVerificationCodeError: (backendErrorCode) => {
		switch (backendErrorCode) {
			case "activationCodeInvalid":
				return "verification_code_page_invalid_code_error";
			case "expiredActivationCode":
				return "verification_code_page_expired_code_error";
			case "activationCodeRetryLimit":
				return "verification_code_page_retry_limit_error";
			default:
				return "verification_code_page_unexpected_error";
		}
	},
	parseVerificationCodeErrorResponse: (errorResponse) => {
		const errors = { codeAttemptsLeft: null, hideCodeEntryControls: false, errorMessage: null };
		if (!errorResponse) {
			return errors;
		}

		if (errorResponse.timesCodeAttempted && errorResponse.codeAttemptLimit) {
			errors.codeAttemptsLeft = Math.max(errorResponse.codeAttemptLimit - errorResponse.timesCodeAttempted, 0);
		}
		if (errors.codeAttemptsLeft === 0) {
			errors.hideCodeEntryControls = true;
			errors.errorMessage = "verification_code_page_retry_limit_error";
		}

		return errors;
	}
};

export default ErrorMessagesService;
